// Module
var code = `<style>:host{display:block;width:50px;height:50px}</style>`;
// Exports
export default code;